import {
  type ReactElement,
  isValidElement,
  cloneElement,
} from "react";
import { TooltipRenderProps } from "react-joyride";
import { offset } from "@floating-ui/react-dom";

import {
  Gear,
  LinkSimple,
  MoneyBill,
  MoneyCheckPen,
  RocketLaunch
} from "@unified-checkout/design-system/icons/index";


const JOYRIDE_TOUR_ELEMENT_ID = 'joyride-target-element-{{id}}';
export const JOYRIDE_TOUR_ELEMENT_WRAPPER_ID = 'wrapper-joyride-target-element-{{id}}';
export const getJoyRideElementId = (id: number) => JOYRIDE_TOUR_ELEMENT_ID.replace('{{id}}', id.toString());
export const getJoyRideElementWrapperId = (ids: number | number[]) =>
  Array.isArray(ids) ?
    ids.map(id => JOYRIDE_TOUR_ELEMENT_WRAPPER_ID.replace('{{id}}', id.toString())).join(' ')
    :
    JOYRIDE_TOUR_ELEMENT_WRAPPER_ID.replace('{{id}}', ids.toString());


export const CustomTooltip = ({ step, index, size, closeProps, primaryProps, backProps, skipProps }: TooltipRenderProps) => (
  <>
    {isValidElement(step.content) ?
      cloneElement(
        step.content as ReactElement, {
        ...(step.content as ReactElement).props,
        step: index + 1,
        totalNumberOfSteps: size,
        joyRideProps: { step, index, size, closeProps, primaryProps, backProps, skipProps }
      })
      :
      step.content
    }
  </>
);


const TestLiveMode = (t: any) => <>
  <div>
    {t('innerLayout.dashboardGuide.steps.content.testLive.useTestModeTo')}
  </div>
  <ul>
    {
      ([].concat(t('innerLayout.dashboardGuide.steps.content.testLive.list', { returnObjects: true })) as string[])
        .map((item: string, i: number) =>
          <li key={i}>{item}</li>
        )
    }
  </ul>
  <div data-space-top>
    {t('innerLayout.dashboardGuide.steps.content.testLive.switchWhenReady')}
  </div>
</>;

const PaymentLinks = (t: any) => <>
  <div>
    {t('innerLayout.dashboardGuide.steps.content.paymentLinks.createPls')}
  </div>
  <div>
    {t('innerLayout.dashboardGuide.steps.content.paymentLinks.inFewClicks')}
  </div>
  <ul>
    {
      ([].concat(t('innerLayout.dashboardGuide.steps.content.paymentLinks.list', { returnObjects: true })) as string[])
        .map((item: string, i: number) =>
          <li key={i}>{item}</li>
        )
    }
  </ul>
</>;

const Settings = (t: any) => <div>
  {t('innerLayout.dashboardGuide.steps.content.settings.brandUrCheckout')}
</div>;

const Transactions = (t: any) => <>
  <div>
    {t('innerLayout.dashboardGuide.steps.content.transactions.stayOnTop')}
  </div>
  <div>
    {t('innerLayout.dashboardGuide.steps.content.transactions.filterBy')}
  </div>
  <ul>
    {
      ([].concat(t('innerLayout.dashboardGuide.steps.content.transactions.list', { returnObjects: true })) as string[])
        .map((item: string, i: number) =>
          <li key={i}>{item}</li>
        )
    }
  </ul>
</>;

const Balance = (t: any) => <>
  <div>
    {t('innerLayout.dashboardGuide.steps.content.balance.trackUrMoney')}
  </div>
  <div>
    {t('innerLayout.dashboardGuide.steps.content.balance.see')}
  </div>
  <ul>
    {
      ([].concat(t('innerLayout.dashboardGuide.steps.content.balance.list', { returnObjects: true })) as string[])
        .map((item: string, i: number) =>
          <li key={i}>{item}</li>
        )
    }
  </ul>
</>;

const offsetConfig = offset({ crossAxis: 10 });

export const StepsContent = (t: any, lang: 'en' | 'ar') => [
  {
    node: TestLiveMode(t),
    placement: 'bottom-end',
    floatingOptions: { middleware: [offsetConfig] }
  },
  {
    node: PaymentLinks(t),
    placement: 'bottom-end',
    floatingOptions: { middleware: [offsetConfig] }
  },
  {
    node: Settings(t),
    placement: 'bottom-end',
    floatingOptions: { middleware: [offsetConfig] }
  },
  {
    node: Transactions(t),
    placement: lang === 'en' ? 'right' : 'left',
    floatingOptions: { middleware: [offsetConfig] }
  },
  {
    node: Balance(t),
    placement: lang === 'en' ? 'right' : 'left',
    floatingOptions: { middleware: [offsetConfig] }
  }
];

export const StepsIcons = [
  RocketLaunch,
  LinkSimple,
  Gear,
  MoneyCheckPen,
  MoneyBill
];